import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ProgressManager;
import { PopupManager } from "abreact/popup/PopupManager";
import { ProgressManagerPopup } from "abreact/progress/manager/ProgressManagerPopup";
import { AbWebServices } from "abweb/service/AbWebServices";
import { action, makeObservable, observable } from "mobx";
import * as React from "react";
export class ProgressManager {
  constructor() {
    // List of ProgressActions that we are keeping track of
    _defineProperty(this, "taskList", void 0);
    // The layer showing all the blocking progress feedback
    _defineProperty(this, "popupHandle", null);
    // The component showing all the blocking progress feedback.  The only thing on the layer.
    _defineProperty(this, "_progressManagerPopup", null);
    // Can't let mobx rely on decorators because of the static initializer. Use annotations map instead.
    makeObservable(this, {
      taskList: observable,
      showProgressAction: action,
      hideProgressAction: action
    });
    this.taskList = [];
  }

  // Name for uniqifying tasks.

  static get singleton() {
    if (ProgressManager._singleton == null) {
      throw new Error("Not ready!");
    }
    return ProgressManager._singleton;
  }
  static showGlobalSpinney() {
    if (ProgressManager._globalSpinneyShowing) {
      return;
    }
    ProgressManager._globalSpinneyShowing = true;
    const outstandingRequestCounter = AbWebServices.getRPCService().outstandingRequestCounter;
    outstandingRequestCounter.incrementOutstandingRequestCount();
  }
  static hideGlobalSpinney() {
    if (!ProgressManager._globalSpinneyShowing) {
      return;
    }
    ProgressManager._globalSpinneyShowing = false;
    const outstandingRequestCounter = AbWebServices.getRPCService().outstandingRequestCounter;
    if (outstandingRequestCounter.isBusy)
      // safety check
      {
        outstandingRequestCounter.decrementOutstandingRequestCount();
      }
  }
  showProgressAction(a, popupProps) {
    this.log(`showProgressAction: ${a.name}, popupProps: ${popupProps.layerGroupId}/${popupProps.id}, popupHandle: ${this.popupHandle}, taskList: ${this.taskList}`);
    if (!this.popupHandle) {
      this.log(`showProgressAction: ${a.name}: opening`);
      this.popupHandle = PopupManager.show(/*#__PURE__*/React.createElement(ProgressManagerPopup, {
        startOfTime: new Date(),
        displayDelay: popupProps.displayDelay,
        ref: x => {
          this._progressManagerPopup = x;
        }
      }), popupProps);
    }
    if (!a.showing) {
      a.showing = true;
      this.taskList.push(a);
    }
    // already showing, show again
    if (this._progressManagerPopup) {
      this._progressManagerPopup.forceUpdate();
    }
  }
  hideProgressAction(a) {
    this.log(`hideProgressAction: ${a.name}, popupHandle: ${this.popupHandle}, taskList: ${this.taskList}`);
    const index = this.taskList.indexOf(a);
    if (index >= 0) {
      a.showing = false;
      this.taskList.splice(index, 1);
    }
    if (this.taskList.length === 0 && this.popupHandle != null) {
      this.log(`hideProgressAction: ${a.name}: closing`);
      this.popupHandle.close();
      this.popupHandle = null;
      ProgressManager.hideGlobalSpinney();
    }
  }
  clearBeforeRouteChange() {
    // on a major route change, we kill all the popups, so we need to nuke our handle
    if (this.popupHandle != null) {
      this.popupHandle.close();
      this.popupHandle = null;
    }
  }
  reshowAfterRouteChange(popupProps) {
    if (this.taskList.length > 0 && this.popupHandle == null) {
      this.popupHandle = PopupManager.show(/*#__PURE__*/React.createElement(ProgressManagerPopup, {
        startOfTime: new Date(),
        ref: x => {
          this._progressManagerPopup = x;
        }
      }), popupProps);
    }
  }

  /**
   * Used for testing only
   */
  static cleanupForTests() {
    ProgressManager.singleton.taskList = [];
    ProgressManager.singleton.popupHandle = null;
  }
  log(s) {
    // console.log(`*** [${new Date().toISOString()}] ProgressManager: ${s}`);
  }
}
_ProgressManager = ProgressManager;
_defineProperty(ProgressManager, "taskNum", 0);
_defineProperty(ProgressManager, "_singleton", null);
// Is the global spinney is showing?   Because we're a singleton, last call wins.
_defineProperty(ProgressManager, "_globalSpinneyShowing", false);
// @ts-ignore: noUnusedLocals
_defineProperty(ProgressManager, "staticInitializer", function () {
  _ProgressManager._singleton = new _ProgressManager();
}());
// Note the extra parens! We're declaring AND calling the function at module load time, effectively making a static initializer!
_defineProperty(ProgressManager, "ELAPSED_TIME_DELAY_SECONDS", 14);
//# sourceMappingURL=ProgressManager.js.map
